module.exports = __webpack_public_path__ + "img/logo_white.ae8e6106.svg";